import $ from "jquery";
import uly from "ulysses/base";
import ko from "knockout";
import HalResource from "./api";
import dialog_markup from "ulysses/dialog.html";
import raw_dialog_markup from "ulysses/dialog_raw.html";
import progress_markup from "ulysses/dialog_progress.html";

//$(document).ready(function() { $(dialog_markup).appendTo($("body")); });
$(document).ready(function() {
    $(document).on("hidden.bs.modal", ".modal", function () {
        $(".modal:visible").length && $(document.body).addClass("modal-open");
    }).on("shown.bs.modal", function(e) {
        $(e.target).find(".form-control:visible:first").focus();
    });
});


function _prepare_buttons(buttons, dialog_data) {
    let new_buttons = [];
    if (!buttons || (!buttons.length && !Object.isObject(buttons))) {
        new_buttons = [
            { "button":"cancel", "caption":_("modal_caption_cancel", "Cancel"), "button_class":"pull-left btn", "icon":"fa fa-times-circle", "action":"closedialog"},
            { "button":"ok", "caption":"Ok", "button_class":"btn btn-primary", "icon":"fa fa-check-circle", "action":"closedialog"}
        ];
    }
    else {
        $.each(buttons, function(key,value) {
            var bt;
            if (Object.isObject(value)) {
                if (typeof key == "number") {
                    bt = $.extend({ "action":"closedialog", "button_class":"btn" }, value);
                }
                else bt = $.extend({ "action":"closedialog", "button_class":"btn", "button":key }, value);
            }
            else {
                bt = { "action":"closedialog", "button_class":"btn", "caption":value, "button":key };
            }
            if (bt.button == "ok" ) {
                if (!bt.button_class || bt.button_class.indexOf("btn")<0 || bt.button_class=="btn")
                    bt.button_class = "btn btn-primary";
                if (!bt.icon)
                    bt.icon = "fa-check-circle";
            }
            else if (bt.button == "cancel") {
                if (!bt.button_class || bt.button_class.indexOf("btn")<0 || bt.button_class=="btn")
                    bt.button_class = "pull-left btn btn-default";
                if (!bt.icon)
                    bt.icon = "fa-times-circle";
            }
            else {
                if (bt.colour && bt.button_class=="btn") {
                    bt.button_class = "btn btn-"+bt.colour;
                }
            }
            new_buttons.push(bt);
        });
    }

    new_buttons = new_buttons.map((bt)=>{
        if (typeof dialog_data[bt.button +"_button_hidden"] != "undefined") {
            var _hidden = ko.observable(false);
            bt.hidden = ko.pureComputed({
                "read": function() {
                    return (_hidden() || ko.unwrap(dialog_data[bt.button])); },
                "write": function(v) { _hidden(v); }
            });
        } else {
            bt.hidden = ko.observable(false);
        }

        if (typeof dialog_data[bt.button+"_button_caption"] != "undefined") {
            var c = bt.caption;
            bt.caption = ko.pureComputed(function() {
                return ko.unwrap(dialog_data[bt.button+"_button_caption"]) || c;
            });
        }
        return bt;

    })

    return ko.observableArray(new_buttons);
}


var _cached_dialogs = {};
uly.dialogs = $.extend(uly.dialogs, {
    running_epics: ko.observableArray([]),
    epic_dialog: ko.observable(null),
    show: function(dialog, options, data) {
        var d = Promise.Deferred();
        options = $.extend({no_process:false,keyboard:true}, options||{});
        uly.dialogs.get_markup(dialog).then((markup) => {
            var def = null;
            if (options.no_process) {
                def = Promise.Deferred().resolve({ "data":data, "dialog_options":{} });
            }
            else def = uly.dialogs.get_data(dialog, data);
            def.then((dialog_data) => {
                var opts = $.extend(options, dialog_data.dialog_options || {});
                uly.dialogs.execute(markup, opts, dialog_data.data)/*.progress(function(data){
                    d.notify(data);
                })*/.then(
                    ([result, ui, button, server_result]) => {
                        d.resolve([result, ui, button, server_result]);
                    },d.reject
                );
            }, d.reject);
        }, d.reject);
        return d;
    },
    show_entity: function(entity_name, view, data) {
    },
    get_markup: function(dialog) {
        var res = Promise.Deferred();
        if (!dialog)
        {
            res.reject({ "success":false, "error":_("modal_error_invalid_dialog", "Invalid dialog") });
            return res;
        }
        var cached_markup = _cached_dialogs[dialog];
        if (cached_markup)
        {
            res.resolve(cached_markup);
        }
        else {
            if (dialog.indexOf("http://") == 0 || dialog.indexOf("https://") == 0) {
                var markup_resource = HalResource(dialog).follow("uly:markup", { "type":"html" });
            }
            else markup_resource = uly.api.start().follow("uly:dialogs").follow("uly:findmarkup", { "rel":dialog, "type":"html" });
            markup_resource.done(function(markup) {
                _cached_dialogs[dialog] = markup;
                res.resolve(markup);
            }).fail(res.reject);
        }
        return res;
    },
    get_data: function(dialog, data) {
        var res = Promise.Deferred();
        if (dialog.indexOf("http://") == 0 || dialog.indexOf("https://") == 0) {
            var dialog_resource = HalResource(dialog);
        }
        else dialog_resource = uly.api.start().follow("uly:dialogs").follow("find", { "rel":dialog });

        dialog_resource.follow("uly:results", { "q":data} ).done(function(dialog_data) {
            res.resolve(dialog_data);
        }).fail(res.reject);

        return res;
    },
    execute: function(markup, options, data) {
        var dlgtmpl = $(options.custom ? raw_dialog_markup : dialog_markup );
        var $dlgelt = $(dlgtmpl).appendTo($("body")).hide().trap();

        var dialog_data = data;
        if (!options.raw_data) {
            dialog_data = ko.mapping.fromJS(data||{});
        }

        var new_buttons = _prepare_buttons(ko.toJS(options.buttons), dialog_data);

        var execution_result = Promise.Deferred();
        var new_data = $.extend(options,  {
            "dialog_data":dialog_data,
            "markup":markup,
            "buttons":new_buttons,
            "selected_data":ko.observableArray([]),
            "progress": ko.observable(null)
        });
        if (typeof new_data.title == "undefined")
            new_data.title = ko.computed(new_data.dialog_data.title || ko.observable(_("modal_test_dialog", "Test Dialog")));
        new_data.content = ko.observable(markup);
        ko.applyBindings(new_data, $dlgelt[0]);
        //ok we've got markup.
        //now setup validator.
        var validator = null;
        var validatable_fields = $dlgelt.find("[validate]");
        var $dialog_form = $dlgelt.find("form[name=dialogform]");

        if (validatable_fields.length > 0) {
            // var validation_rules =  {};
            // $.each(validatable_fields, function(idx, field) {
            //     validation_rules[$(field).attr("name") || $(field).attr("id")] =
            //         $(field).data("validation");
            // });
            validator = $dialog_form.validate({
                //rules:validation_rules,
                highlight: function(element, errorClass, validClass) {
                    $(element).addClass(errorClass).removeClass(validClass);
                    $(element).parents(".form-group").addClass("has-error");
                },
                unhighlight: function(element, errorClass, validClass) {
                    $(element).addClass(validClass).removeClass(errorClass);
                    $(element).parents(".form-group").removeClass("has-error");
                    $(element).next(".error").remove();
                }
            });
            validator.showLabel = function(element, message) {
                var $l = $(element).next(".error");
                if ($l.length)
                    $l.remove();
                $("<label></label>").addClass("error").text(message).insertAfter($(element));
            };
        }

        if (new_data.keyboard) {
            $dlgelt.bind("keypress", function(e) {
                if (e.keyCode == 13) {
                    var ok = $dlgelt.find("[data-button=ok]").first();
                    var wait = $dlgelt.find("[data-button=wait]").first();
                    if (ok.length || wait.length){
                        $(e.target).trigger("blur");
                        $dlgelt.find("[tabindex=1]").first().focus();
                        ok.length&&ok.trigger("click", [e, ko.dataFor($dlgelt[0])]);
                        wait.length&&wait.trigger("click", [e, ko.dataFor($dlgelt[0])]);
                    }

                }
            });
        } else {
            new_data.keyboard = false;
        }

        $dlgelt.bind("action:closedialog", function(ev,ui) {
            var button_pressed = $(ev.target).data("button");
            if (button_pressed != "cancel") {
                var is_valid = true;
                if (typeof options.validate == "function") {
                    is_valid = options.validate($dlgelt, ev, ui);
                }
                else if (validator) {
                    if (validator.currentForm) {
                        var errorList = validator.errorList;
                        validator.errorList = [];
                        let validatables = $(validator.currentForm).find("[validate='validate']").not(validator.settings.ignore);
                        validatables.each((idx, elt) => {
                            let valid = validator.check(elt);
                            is_valid = is_valid && (valid || false);
                        });
                    } else {
                        validator.checkForm();
                        validator.defaultShowErrors();
                        is_valid = validator.valid();
                        is_valid = (is_valid === null || typeof is_valid === "undefined") ? true : is_valid;
                    }
                }
                else is_valid = true;

                if (!is_valid) {
                    //do not resolve at this point.
                    return false;
                }

                var progress = {
                    "value": ko.observable(10),
                    "info": ko.observable(_("dialog_progress_submit", "Submitting data")),
                    "colour": ko.observable("primary")
                };
                options.progress(progress);
                var epic_id = ko.unwrap(options.epic_id);
                //subscribe to epic progress.
                var closure_data = new_data.dialog_data;
                if (ui.context.$parent && ui.context.$parent.dialog_data)
                    closure_data = ui.context.$parent.dialog_data;
                if (typeof options.before_close == "function") {
                    var epicSub = null;
                    var update_progress = function(topic, data) {
                        progress.value(40 + (data.progress * 60 / 100));
                        if (data.description) {
                            progress.info(data.description);
                        }
                        if (data.success || typeof data.success == "undefined") {
                            progress.colour("primary");
                        } else {
                            progress.colour("danger");
                        }
                    };


                    if (epic_id) {
                        epicSub = uly.subscribeToEpic(epic_id, update_progress);
                        execution_result.always(function() {
                            uly.unsubscribeToEpic(epic_id, epicSub);
                        });
                    }

                    options.before_close(closure_data, button_pressed).then(function(result_) {
                        progress.value(40);
                        console.log("Got before close result:", result_)
                        if (typeof result_.success != "undefined") {
                            uly.utils.show_results(result_);
                            if (result_.success){
                                if (result_.wait_for_epic) {
                                    //waiting for epic to finish.
                                    var eid = epic_id;
                                    if (result_.wait_for_epic !== true && result_.wait_for_epic != eid) {
                                        console.log("switching epic:", result_.wait_for_epic, "<--", eid);
                                        eid = result_.wait_for_epic;
                                        uly.dialogs.finish_epic(epic_id);
                                        uly.dialogs.progress_epic(ko.unwrap(new_data.title), eid);
                                        execution_result.resolve([ko.toJS(closure_data), ui, button_pressed, result_]);
                                        $dlgelt.modal("hide");
                                    } else {
                                        var sub = uly.subscribeToEpic(eid, function(topic, data) {
                                            console.log("update progress:", eid, data);
                                            update_progress(topic, data);
                                            if (data.finished) {
                                                execution_result.resolve([ko.toJS(closure_data), ui, button_pressed, result_]);
                                                $dlgelt.modal("hide");
                                            }
                                        });
                                        execution_result.always(function() {
                                            uly.dialogs.finish_epic(eid);
                                            uly.unsubscribeToEpic(eid, sub);
                                        });
                                    }
                                } else {
                                    options.progress().value(100);
                                    execution_result.resolve([ko.toJS(closure_data), ui, button_pressed, result_]);
                                    $dlgelt.modal("hide");
                                }
                            }else{
                                progress.colour("danger");
                                options.progress(null);
                                if (epic_id)
                                    uly.unsubscribeToEpic(epic_id, epicSub);
                                //client side validation alert (it will wait a bit)
                            }
                        } else if (result_) {
                            execution_result.resolve([ko.toJS(closure_data), ui, button_pressed, result_]);
                            options.progress(null);
                            $dlgelt.modal("hide");
                        }
                    }).fail(function(error_result){
                        if (epic_id)
                            uly.unsubscribeToEpic(epic_id, epicSub);
                        options.progress(null);
                        console.log("got error:", error_result, "typeof:", typeof error_result, "arguments:", arguments);
                        try {
                            if (error_result && error_result.responseText)
                                error_result = JSON.parse(error_result.responseText);
                        }
                        catch(e) {
                            //
                        }
                        if (typeof error_result.success != "undefined")
                            uly.utils.show_results(error_result);
                        else uly.utils.show_results({
                            "success":false,
                            "error":_("modal_error_could_not_complete_action", "Could not complete action.")
                        });
                    });
                } else {
                    execution_result.resolve([ko.toJS(closure_data), ui, button_pressed, null]);
                    $dlgelt.modal("hide");
                }
            } else {
                $dlgelt.modal("hide");
                execution_result.reject([closure_data, ui, button_pressed]);
            }
            ev.preventDefault();
            return false;
        });
        $dlgelt.on("show.bs.modal", function(e) {
            (e.namespace == "bs.modal")&&$("html").css("overflow-y", "hidden");
        }).on("hide.bs.modal", function(e) {
            (e.namespace == "bs.modal")&&$("html").css("overflow-y", "auto");
        }).on("hidden.bs.modal", function() {
            $(".modal-backdrop").remove();
            //clean node first to trigger dispose callbacks
            //as empty() doesn't.
            ko.cleanNode($dlgelt[0]);
            $dlgelt.empty().remove();
            $dlgelt = null;

            if (execution_result.state() == "pending"){
                execution_result.reject();
            }
        }).modal({keyboard:new_data.keyboard, backdrop: "static"});
        execution_result.$elt = $dlgelt;
        return execution_result;

    },
    "ask_user": function(title, message, yes_caption, no_caption) {
        var deferred = Promise.Deferred();
        var new_buttons = [
            { "button":"cancel", "caption":no_caption || _("modal_ask_user_btn_cancel", "Cancel"), "button_class":"btn", "icon":"fa fa-times-circle", "action":"closedialog"},
            { "button":"ok", "caption":yes_caption || _("modal_ask_user_btn_ok", "Ok"), "button_class":"btn btn-primary", "icon":"fa fa-check-circle", "action":"closedialog"}
        ];
        uly.dialogs.execute("<p>"+message+"</p>", { "title":title, buttons:new_buttons }, {})
            .done(function() {
            deferred.resolve();
        }).fail(function() {
            deferred.reject();
        });
        return deferred.promise();
    },
    "remove_epic": function(progress, final_status) {
        uly.dialogs.running_epics.remove(progress);
        if (uly.dialogs.running_epics().length <= 0) {
            var dlgRes = uly.dialogs.epic_dialog();
            if (dlgRes && dlgRes.$elt) {
                dlgRes.$elt.modal("hide");
            }
            if (final_status) {
                if (progress.colour() == "danger") {
                    uly.utils.show_results({"success": false, "error": final_status });
                } else {
                    uly.utils.show_results({"success": true, "info": final_status});
                }
            }
        }

    },
    "progress_dialog": function(title, status_obs, progress_obs) {
        var progress = {
            "value": ko.observable(0),
            "info": status_obs,
            "colour": ko.observable("primary"),
            "title": title,
            "epic_id": 0,
            progress_obs: progress_obs
        };

        status_obs.subscribe((newvalue) => {
            if (!newvalue) {
                uly.dialogs.remove_epic(progress);
            }
        });

        uly.dialogs.running_epics.push(progress);
        var deferred = Promise.Deferred();
        uly.dialogs.show_epics().then(deferred.resolve, deferred.reject);
        return deferred.promise();
    },
    "progress_epic": function(title, epic_id, info) {
        if (!epic_id) return;
        if (!info) {
            info = _("dialog_progress_submit", "Submitting data");
        }
        var progress = uly.dialogs.running_epics().filter((e)=> { return e.epic_id == epic_id; })[0];
        if (typeof progress == "undefined") {
            progress = {
                "value": ko.observable(0),
                "info": ko.observable(info),
                "colour": ko.observable("primary"),
                "title": title,
                "epic_id": epic_id
            };
            progress.progress_obs = ko.pureComputed(function() {
                return (progress.value() * 0.9) + 10  + "%";
            });
            uly.dialogs.running_epics.push(progress);
        } else {
            progress.title = title;
            progress.info(info);
        }
        var epicSub = null;
        var $elt = null;
        epicSub = uly.subscribeToEpic(epic_id, function(topic, data) {
            progress.value(data.progress);
            if (data.description) progress.info(data.description);
            if (data.success || typeof data.success == "undefined") {
                progress.colour("primary");
            } else {
                progress.colour("danger");
            }
            if (data.finished) {
                uly.unsubscribeToEpic(epic_id, epicSub);
                uly.dialogs.remove_epic(progress, data.description);
            }
        });
        return uly.dialogs.show_epics();
    },
    "finish_epic": function(epic_id) {
        uly.dialogs.running_epics().filter((e) => { e.epic_id == epic_id}).forEach((e) => {
            uly.publish("socket.epic.progress."+epic_id.toLowerCase(), { finished: true });
        });
    },
    "show_epics": function() {
        var dlgRes = uly.dialogs.epic_dialog();
        if (!dlgRes) {
            var dlgRes = uly.dialogs.execute(progress_markup, {
                "raw_data": true,
                "title":_("progress_dialog_tasks_in_progress", "Tasks in progress"),
                "buttons":[{ "button":"cancel", "caption": _("progress_epic_hide", "Hide")}]
            }, {
                "tasks": uly.dialogs.running_epics
            });
            dlgRes.always(()=> { uly.dialogs.epic_dialog(null); });
            uly.dialogs.epic_dialog(dlgRes);

            // dlgRes.always(function() {uly.unsubscribeToEpic(epic_id, epicSub); });
        }
        return dlgRes;

    },
    "search_entity":function(entity, title, caption, yes_caption, no_caption, search_options) {
        var deferred = Promise.Deferred();
        var new_buttons = [
            { "button":"cancel", "caption":no_caption || _("modal_search_entity_btn_cancel", "Cancel"), "button_class":"btn", "icon":"fa fa-times-circle", "action":"closedialog"},
            { "button":"ok", "caption":yes_caption || _("modal_search_entity_btn_ok", "Ok"), "button_class":"btn btn-primary", "icon":"fa fa-check-circle", "action":"closedialog"}
        ];
        search_options = search_options || {};
        var filter = search_options.filters || "";
        if (filter && filter.length) {
            filter = "("+filter+") AND type:"+entity;
        } else {
            filter = "type:"+entity;
        }
        search_options.filter = filter;
        var search_template = "\
<div data-bind=\"searchpopup:$data\"><div data-bind=\"search:$data, search_template:'search-results-tmpl', result_template:'searchbox-result-tmp'\">\
</div></div>";
        var res = uly.dialogs.execute(
            search_template,
            {"title": title, buttons: new_buttons},
            search_options
        );
        res.done(function([result]) {
            deferred.resolve(result.selection);
        }).fail(function() {
            deferred.reject();
        });
        return deferred.promise();
    },
    "lookup_value":function(entity, title, caption, yes_caption, no_caption, lookup_options) {
        var deferred = Promise.Deferred();
        var new_buttons = [
            { "button":"cancel", "caption":no_caption || _("modal_lookup_value_btn_cancel", "Cancel"), "button_class":"btn", "icon":"fa fa-times-circle", "action":"closedialog"},
            { "button":"ok", "caption":yes_caption || _("modal_lookup_value_btn_ok", "Ok"), "button_class":"btn btn-primary", "icon":"fa fa-check-circle", "action":"closedialog"}
        ];
        lookup_options = lookup_options || {};
        var filter = lookup_options.filters || null;
        if (!filter)
            filter ="''";
        else if (Array.isArray(filter)) {
            filter = "['" + filter.join("','") + "']";
        }
        else {
            filter = "['"+filter+"']";
        }
        var placeholder = _("modal_lookup_value_placeholder_choose", "Choose {0}...");
        var lookup_template = "\
<div class=\"form-group\">\
   <label>" + caption + "</label>\
   <select tabindex=\"1\" data-container=\"body\" placeholder=\""+placeholder.format(caption)+"\" \
    data-bind=\"lookupValue:entity_id,lookup:'"+entity+"',lookupPresentation:entity,filters:"+filter+"\" \
    class=\"selectpicker form-control\" data-live-search=\"true\"><option></option> </select>";

        uly.dialogs.execute(lookup_template, {
            "title":title,
            buttons:new_buttons
        }, {
            "entity":{
                "unique_id":ko.observable(null),
                "id":ko.observable(null),
                "name":ko.observable(""),
                "key_code":ko.observable(null),
                "colour":ko.observable(null),
                "icon":ko.observable(null)
            },
            "entity_id":ko.observable(null)
        }).done(function([result]) {
            deferred.resolve(result.entity);
        }).fail(function() {
            deferred.reject();
        });
        return deferred.promise();
    }

});
uly.dialogs = Object.freeze(uly.dialogs);
